import { createTheme } from "@mui/material/styles"
import { focusFirstField } from "utils/focusHelper"

// Create a function that generates the theme based on userData
const createDynamicTheme = (userData) => {
  // Extract theme settings or use defaults if not available
  const themeSettings = userData
  const primaryColor = themeSettings?.primary_color || "#000000"
  const secondaryColor = themeSettings?.secondary_color || "#ffffff"
  const highlightColor = themeSettings?.highlight_color || "#f4f6f9"

  return createTheme({
    palette: {
      background: {
        default: "#ffffff",
        paper: "#ffffff",
        darkBackground: "#000000",
      },
      text: {
        primary: "#000000",
        secondary: "#757575",
        label: "#374151",
        grayText: "#4B5563",
        white: "#ffffff",
      },
      primary: {
        main: primaryColor, // Dynamic primary color
      },
      secondary: {
        main: secondaryColor, // Dynamic secondary color
      },
      highlight: {
        main: highlightColor, // Dynamic highlight color
      },
      lightgray: {
        main: "#f4f6f9",
      },
      red: {
        main: "#c31f1f",
      },
      drawermenuitem: {
        main: '#4D4D4D',
      },
      typographyLabel: {
        main: '#000000'
      },
      lightgrey: {
        main: "#A1A1A1"
      },
    },
    // fontFamily: "Roboto, Arial, sans-serif",
    fontFamily: "system-ui",
    typography: {
      // fontFamily: "Roboto, Arial, sans-serif",
      fontFamily: "system-ui",
      h5: {
        fontSize: "1.5rem",
        fontWeight: 500,
      },
      h6: {
        fontSize: "1.25rem",
        fontWeight: 400,
      },
      body1: {
        fontSize: "1rem",
        lineHeight: 1.5,
      },
      body2: {
        fontSize: "0.875rem",
      },
      subtitle1: {
        fontSize: "0.875rem",
      },
      subtitle2: {
        fontSize: "0.75rem",
      },
      span: {
        fontSize: "0.75rem",
      },
      p: {
        fontSize: "0.875rem",
      },
    },
    formFileds: {
      borderRadius: "10px",
      height: "45px",
    },
    components: {
      MuiDialog: {
        defaultProps: {
          TransitionProps: {
            onEntered: (node) => {
              focusFirstField(node);
            },
          },
        },
      },
    },
  })
}

// Export the theme creation function instead of a static theme
export default createDynamicTheme
